import Reveal from "@/components/Reveal";

export default function About() {
  return (
    <section id="about" className="border-b border-line bg-[#F7EFE3]">
      <div className="mx-auto max-w-7xl px-6 py-24 md:py-32">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink/60">
                04 — About
              </p>
              <h2
                className="mt-6 font-serif text-4xl leading-tight tracking-tight md:text-5xl"
                data-testid="about-headline"
              >
                We are operators,
                <br />
                not advisors. <em className="text-gold">We stay</em>
                <br />
                after the deck.
              </h2>
            </Reveal>
          </div>
          <div className="flex flex-col justify-end md:col-span-5">
            <Reveal delay={0.15}>
              <p className="text-base leading-relaxed text-ink/70" data-testid="about-founder">
                Crestbridge is founded on 19 years of experience inside global
                organisations, specialised in the shared services industry —
                managing global investments for corporate functions and building
                the governance models and FP&amp;A capabilities behind them.
              </p>
              <p className="mt-6 text-base leading-relaxed text-ink/70">
                That is what we bring to your India GCC: the judgment of someone
                who has sat on your side of the table, made the investment case,
                and answered for the governance. We take accountability for the
                outcome, not the invoice.
              </p>
              <div className="mt-10 grid grid-cols-2 gap-px border border-line bg-line">
                <div className="bg-[#F7EFE3] p-6">
                  <p className="font-serif text-3xl">19+</p>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">
                    Years in global shared services
                  </p>
                </div>
                <div className="bg-[#F7EFE3] p-6">
                  <p className="font-serif text-3xl">3</p>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">
                    Disciplines — investments, governance, FP&amp;A
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
